import { InAppMessage } from "../../../../model/model"
import Evaluation from "../../../Evaluation"
import { InAppMessageEligibilityEvaluateResult } from "./InAppMessageEligibilityEvaluateResult"

export class InAppMessageEligibilityEvaluation implements Evaluation {
  constructor(public readonly entity: InAppMessage, public readonly result: InAppMessageEligibilityEvaluateResult) {}

  get isEligible(): boolean {
    return this.result.isEligible
  }
}
